module.exports = __webpack_public_path__ + "static/media/taizu_thumb.64dfa292.jpg";